import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import alerts from "./alerts";
import appointment from "./appointment";
import article from "./article";
import blocGrid from "./blocGrid";
import blockedNumbers from "./blockedNumbers";
import clinic from "./clinic";
import contact from "./contact";
import conversation from "./conversation";
import conversationList from "./conversationList";
import consultation from "./consultation";
import groups from "./groups";
import login from "./login";
import onboarding from "./onboarding";
import sip from "./sip";
import ui from "./ui";
import voice from "./voice";
import calls from "./calls";
import scheduledMessages from "./scheduledMessages";
import vacationsV2 from "./vacationsV2";
import localeFilter from "./localeFilter";
import emailInbox from "@/store/emailInbox";
import faxes from "@/store/faxes";
import connector from "./connector";

Vue.use(Vuex);

const persistedState = createPersistedState({
	paths: [
		"blocGrid.activePostType",
		"clinic.clinicData",
		"contact.options",
		"consultation.isPatientSelected",
		"consultation.patient",
		"conversation.audioNotificationsEnabled",
		"conversation.desktopNotificationsEnabled",
		"conversation.browserNotificationsDisabled",
		"conversation.showNotificationsAlert",
		"conversation.signatureOption",
		"sip",
		"localeFilter",
		"ui",
		"voice.showIncomingCallAlert",
		"voice.activeInputId",
		"voice.activeOutputId",

		// Persistent login states only
		"login.jwt",
		"login.expires",
		"login.eventsToken",
		"login.profile",
		"login.userGroup",
		"login.userStatus",
		"login.forgottenEmail",
		"login.logoutTrigger",
		"login.colors"
	]
});

const modules = {
	alerts,
	appointment,
	article,
	blocGrid,
	blockedNumbers,
	clinic,
	consultation,
	contact,
	conversation,
	conversationList,
	groups,
	login,
	localeFilter,
	onboarding,
	sip,
	ui,
	voice,
	calls,
	scheduledMessages,
	vacationsV2,
	emailInbox,
	connector,
	faxes
};

const store = new Vuex.Store({
	modules,
	plugins: [persistedState]
});

Object.entries(modules).forEach(([name, mod]) => {
	if (typeof mod.init === "function") {
		mod.init({
			watch: store.watch.bind(store),
			login: store.state.login,
			state: store.state[name],
			dispatch(type, payload) {
				return store.dispatch(`${name}/${type}`, payload);
			},
			commit(type, payload) {
				return store.commit(`${name}/${type}`, payload);
			}
		}, store);
	}
});

export default store;
